import { render, staticRenderFns } from "./tenantUserModal.vue?vue&type=template&id=52d036ee&"
import script from "./tenantUserModal.vue?vue&type=script&lang=js&"
export * from "./tenantUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports